class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

/**
 * When a fly-out submenu is opened, close sibling details in the same list
 * so only one submenu is open per column (no overlapping panels).
 * We close siblings on both click (before open) and toggle (after open) for reliability.
 */
function closeSiblingSubmenus(details) {
  const list = details.closest('ul.header__submenu');
  if (!list) return;

  Array.from(list.children).forEach((li) => {
    const d = li.querySelector('details');
    if (d && d !== details) {
      d.removeAttribute('open');
      const summary = d.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
  });
}

function initHeaderSubmenuSiblingClose() {
  const nav = document.querySelector('.header__inline-menu');
  if (!nav) return;

  // On toggle (after a details opens): close sibling details in the same list
  nav.addEventListener('toggle', (event) => {
    const details = event.target;
    if (details.tagName !== 'DETAILS' || !details.hasAttribute('open')) return;
    closeSiblingSubmenus(details);
  }, true);

  // On summary click (before open): close sibling fly-outs so only one opens per column
  nav.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (details.tagName !== 'DETAILS') return;
    // Only run for nested submenus (inside a .header__submenu), not the top-level nav item
    const list = details.closest('ul.header__submenu');
    if (!list) return;
    closeSiblingSubmenus(details);
  }, true);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderSubmenuSiblingClose);
} else {
  initHeaderSubmenuSiblingClose();
}
